// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"2979c7c7","399":"ab590844","743":"5de6d65e","948":"71fdafdb"}[chunkId] + ".chunk.js";
};